import { FC, useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'
import { useDebounce } from 'use-debounce'

import { DEBOUNCE_TIMER_300 } from 'src/Constants/constants'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import {
  useGetMetaAdsCampaignByIdQuery,
  useUpdateMetaAdsCampaignMutation,
} from 'src/Redux/adsCampaignApi'
import { useLazyGetSpotifyArtistsQuery } from 'src/Redux/spotifyArtistsApi'

import { AdsArtistsModalHeader } from '../AdsArtistsModalHeader'
import { AdsArtistsModalButtons } from '../AdsArtistsModalButtons'
import { AdsArtistsSearchInput } from '../AdsArtistsSearchInput'
import { AdSelectedArtistsList } from '../AdsArtistsModalReadyToSelectLists/AdSelectedArtistsList'
import { useSelectedArtists } from '../../helpers/useSelectedArtists'
import { AdSearchArtistsList } from '../AdsArtistsModalReadyToSelectLists/AdSearchArtistsList'

export const AdsArtistsModalContent: FC = () => {
  const { setSearch } = useCustomSearchParams()
  const [searchValue, setSearchValue] = useState('')
  const [debouncedSearchValue] = useDebounce(searchValue, DEBOUNCE_TIMER_300)

  const { number } = useParams()
  const { data } = useGetMetaAdsCampaignByIdQuery(Number(number))
  const { selectedArtists, onSetSelectedArtists, hasChanges } =
    useSelectedArtists()
  const [updateMetaAdsCampaign] = useUpdateMetaAdsCampaignMutation()

  const [fetchSpotifyArtists, { data: spotifyArtists = [] }] =
    useLazyGetSpotifyArtistsQuery()

  useEffect(() => {
    if (debouncedSearchValue.length >= 1) {
      fetchSpotifyArtists(debouncedSearchValue)
    }
  }, [debouncedSearchValue, fetchSpotifyArtists])

  const handleClick = async (): Promise<void> => {
    await updateMetaAdsCampaign({
      id: Number(data?.id),
      similarArtistNames: selectedArtists.map((artist) => artist.name),
    })
    setSearch({ modal: null })
  }

  return (
    <>
      <AdsArtistsModalHeader />

      <AdsArtistsSearchInput
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />

      <AdSelectedArtistsList
        artists={selectedArtists}
        onClickArtist={onSetSelectedArtists}
      />

      {Boolean(debouncedSearchValue) && (
        <AdSearchArtistsList
          searchValue={debouncedSearchValue}
          selectedArtists={selectedArtists}
          onClickArtist={onSetSelectedArtists}
          artists={spotifyArtists}
        />
      )}

      <AdsArtistsModalButtons
        disabledAdd={!hasChanges}
        onClickAddArtists={handleClick}
        onClickGoBack={() => setSearch({ modal: null })}
      />
    </>
  )
}
